import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
    fetchTipos,
    fetchModelos,
    fetchMarcas,
    fetchSubMarcas,
    fetchDescripciones
} from '../../api/quoteApi';

export const getAutoTipo = createAsyncThunk(
    'catalogos/getAutoTipo',
    async (_, { rejectWithValue }) => {
        try {
            return await fetchTipos();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAutoModelo = createAsyncThunk(
    'catalogos/getAutoModelo',
    async ({ tipo }, { rejectWithValue }) => {
        try {
            return await fetchModelos({ tipo });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAutoMarca = createAsyncThunk(
    'catalogos/getAutoMarca',
    async ({ tipo, modelo }, { rejectWithValue }) => {
        try {
            return await fetchMarcas({ tipo, modelo });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAutoSubMarca = createAsyncThunk(
    'catalogos/getAutoSubMarca',
    async ({ tipo, modelo, marca }, { rejectWithValue }) => {
        try {
            return await fetchSubMarcas({ tipo, modelo, marca });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAutoDescripcion = createAsyncThunk(
    'catalogos/getAutoDescripcion',
    async ({ tipo, modelo, marca, subMarca }, { rejectWithValue }) => {
        try {
            return await fetchDescripciones({ tipo, modelo, marca, subMarca });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const initialState = {

  formValues: {
    tipo: '',
    modelo: '',
    marca: '',
    subMarca: '',
    descripcion: ''
  },

  vehicle: {
    tipos: [],
    modelos: [],
    marcas: [],
    subMarcas: [],
    descripciones: []
  },

  vehicleStatus: {
    initial: 'idle',
    tipos: 'idle',
    modelos: 'idle',
    marcas: 'idle',
    subMarcas: 'idle',
    descripciones: 'idle'
  },

  validValues: {
    tipo: false,
    modelo: false,
    marca: false,
    subMarca: false,
    descripcion: false
  },

  error: null

};

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
        setFormValue: (state, action) => {
            const { field, value } = action.payload;
            state.formValues[field] = value;

            switch (field) {
                case 'tipo':
                    state.formValues.modelo = '';
                    state.formValues.marca = '';
                    state.formValues.subMarca = '';
                    state.formValues.descripcion = '';
                    state.vehicle.modelos = [];
                    state.vehicle.marcas = [];
                    state.vehicle.subMarcas = [];
                    state.vehicle.descripciones = [];
                    state.validValues.modelo = false;
                    state.validValues.marca = false;
                    state.validValues.subMarca = false;
                    state.validValues.descripcion = false;
                    break;
                case 'modelo':
                    state.formValues.marca = '';
                    state.formValues.subMarca = '';
                    state.formValues.descripcion = ''
                    state.vehicle.marcas = [];
                    state.vehicle.subMarcas = [];
                    state.vehicle.descripciones = [];
                    state.validValues.marca = false;
                    state.validValues.subMarca = false;
                    state.validValues.descripcion = false;
                    break;
                case 'marca':
                    state.formValues.subMarca = '';
                    state.formValues.descripcion = '';
                    state.vehicle.subMarcas = [];
                    state.vehicle.descripciones = [];
                    state.validValues.subMarca = false;
                    state.validValues.descripcion = false;
                    break;
                case 'subMarca':
                    state.formValues.descripcion = '';
                    state.vehicle.descripciones = [];
                    state.validValues.descripcion = false;
                break;
                default:
                    break;
            }
        },
        setValidValue: (state, action) => {
            const { field, isValid } = action.payload;
            state.validValues[field] = isValid;
        },
        resetError: (state) => {
            state.error = null;
        },
        resetProcess: () => {
            return initialState;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAutoTipo.pending, (state) => {
            state.vehicleStatus.tipos = 'loading';
            })
            .addCase(getAutoTipo.fulfilled, (state, action) => {
            state.vehicleStatus.tipos = 'succeeded';
            state.vehicle.tipos = action.payload;
            })
            .addCase(getAutoTipo.rejected, (state, action) => {
            state.vehicleStatus.tipos = 'failed';
            state.vehicleError = action.payload;
            })
            .addCase(getAutoModelo.pending, (state) => {
            state.vehicleStatus.modelos = 'loading';
            })
            .addCase(getAutoModelo.fulfilled, (state, action) => {
                state.vehicleStatus.modelos = 'succeeded';
                state.vehicle.modelos = action.payload;
            })
            .addCase(getAutoModelo.rejected, (state, action) => {
                state.vehicleStatus.modelos = 'failed';
                state.vehicleError = action.payload;
            })
            .addCase(getAutoMarca.pending, (state) => {
                state.vehicleStatus.marcas = 'loading';
            })
            .addCase(getAutoMarca.fulfilled, (state, action) => {
                state.vehicleStatus.marcas = 'succeeded';
                state.vehicle.marcas = action.payload;
            })
            .addCase(getAutoMarca.rejected, (state, action) => {
                state.vehicleStatus.marcas = 'failed';
                state.vehicleError = action.payload;
            })
            .addCase(getAutoSubMarca.pending, (state) => {
                state.vehicleStatus.subMarcas = 'loading';
            })
            .addCase(getAutoSubMarca.fulfilled, (state, action) => {
                state.vehicleStatus.subMarcas = 'succeeded';
                state.vehicle.subMarcas = action.payload;
            })
            .addCase(getAutoSubMarca.rejected, (state, action) => {
                state.vehicleStatus.subMarcas = 'failed';
                state.vehicleError = action.payload;
            })
            .addCase(getAutoDescripcion.pending, (state) => {
                state.vehicleStatus.descripciones = 'loading';
            })
            .addCase(getAutoDescripcion.fulfilled, (state, action) => {
                state.vehicleStatus.descripciones = 'succeeded';
                state.vehicle.descripciones = action.payload;
            })
            .addCase(getAutoDescripcion.rejected, (state, action) => {
                state.vehicleStatus.descripciones = 'failed';
                state.vehicleError = action.payload;
            });
    }
});

export const { 
    setFormValue,
    setValidValue,
    resetError, 
    resetProcess 
} = vehicleSlice.actions;

export default vehicleSlice.reducer;